module.exports = __webpack_public_path__ + "img/cp5-4.693da92e.jpg";